import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/1/s/src/components/shoppingCart/index.tsx");
